import { useUser } from "./hooks/use-user";
import type { UsersType } from "./types";

/**
 * How far an account reaches into the platform back-office (`/admin`).
 *
 * `admin` is a SYSADMIN: everything. `read` is the read-only account given to
 * sales (`SYSADMIN_READ`): the client list and a client's file — its overview,
 * its dashboard and its calls, as the client sees them — the global dashboard
 * and the control centre; nothing technical, no explorer, no write. `null`
 * means no back-office at all.
 *
 * The server is what enforces it (`checkStaffRead` on the few routes the read
 * account may call, `checkRole("SYSADMIN")` on every other one); here it only
 * decides what is drawn, so a page the account cannot use is not offered.
 */
export type BackOfficeAccess = "admin" | "read";

export const backOfficeAccess = (
  role?: UsersType["role"],
): BackOfficeAccess | null =>
  role === "SYSADMIN" ? "admin" : role === "SYSADMIN_READ" ? "read" : null;

export const useBackOfficeAccess = (): BackOfficeAccess | null => {
  const { data: user } = useUser();
  return backOfficeAccess(user?.role);
};
